<template>
  <section class="chart card">
    <div class="vld-parent">
      <loading
        :active.sync="loading"
        :can-cancel="true"
        :on-cancel="onCancel"
        :is-full-page="false"
        :background-color="bgColor"
        :opacity="opacity"
      ></loading>
      <b-card>
        <b-container>
          <b-row>
            <b-col>
              <h6>Sankey Diagram of Regional Energy Flows in 2050 (Units are in Quadrillion Btu, “with storage” scenario is shown)</h6>
            </b-col>
          </b-row>
        </b-container>
        <chart-sankey
          id="sankey"
          :data="allSankey"
          :config="chartConfig"
          @rendered="bindSankeyNodeEvents"
        ></chart-sankey>
      </b-card>
      
    </div>
  </section>
</template>

<script>
import * as d3 from 'd3';
import { ChartSankey } from 'vue-d2b';
import JQuery from 'jquery';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

let $ = JQuery;
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Sankey',
  props: ['isLoading'],
  data() {
    return {
      // chartData: {},
      node: {},
      loading: false,
      fullPage: false,
      bgColor: '#fff',
      opacity: 0.5,
      //
      chartConfig(config) {
        config
          .sankey()
          .sankey()
          .nodePadding(10);

        config.sankey().nodeDraggableY(true);
        let color = d3.scaleOrdinal()  
          .domain(["Petroleum","Natural Gas", "Coal", "Nuclear", "Wind", "Solar", "Biomass", "Hydro", "Geothermal", "Electricity", "Residential","Commericial","Industrial","Transportation","Rejected Energy","Energy Services"])
          .range(["#236000", "#48ACF5", "#696969", "#CD0000", "#930992", "#F9D800", "#91EF91", "#0E02FF", "#925909", "#E79B33", "#F6BCC9", "#F6BCC9", "#F6BCC9", "#F6BCC9", "#BBBBBB", "#616161"])
        config.sankey().nodeColor((d, i, key) => {
          return color(key)
        })
        config.sankey().linkTargetColor((d, i, key) => {
          return color(d.source)
        })
        config.sankey().linkSourceColor((d, i, key) => {

          return color(d.source)
        })
        config.nodeTooltip().html(d => `<b>${d.key}</b>: ${d.value.toFixed(4)}`)
        config.linkTooltip().html(d => `<b>${d.key}</b>: ${d.value.toFixed(4)}`)

      }
    };
  },
  methods: {
    ...mapActions(['fetchSampleSankeyLinks', 'fetchSampleSankeyNodes']),
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
      $('.chart').css('width', this.windowWidth - 850);
    },
    bindSankeyNodeEvents() {
      const _this = this;
      d3.selectAll('.d2b-sankey-node').on('click', function(d) {
        _this.node = d;
        // _this.$emit('current-node', _this.node);
      });
    },
    onCancel() {} // loader cancel
  },
  components: {
    ChartSankey,
    Loading
  },
  created() {
    // this.fetchSampleSankeyLinks();
    // this.fetchSampleSankeyNodes();
  },
  beforeDestroy: function() {
    window.removeEventListener('resize', this.handleWindowResize);
  },
  mounted() {
    // this.fetchSampleSankeyLinks();
    // this.fetchSampleSankeyNodes();

    this.$nextTick(function() {
      window.addEventListener('resize', this.handleWindowResize);
    });

    this.loading = true;
    // simulate AJAX
    setTimeout(() => {
      this.loading = false;
    }, 3000);
  },
  watch: {
    isLoading() {
      this.loading = this.isLoading 
    }
  },
  computed: {
    ...mapGetters(['allSankey'])
  }
};
</script>

<style lang="scss" scoped>
#sankey {
  min-height: 380px;
  display: flex;
  flex-direction: column;
  background-color: white;
}
</style>
